import { Content } from '@backstage/core-components';
import {
  CustomViewSummaryMenu,
  MainPageType,
  useLastVisitedMainPage,
  useSearchParamChangeObserver,
  useSessionQueryString,
  WbBreadcrumb,
  WbBreadcrumbs,
  WbEnvironmentSelector,
  WbHeader,
  WbHeaderActions,
} from '@agilelab/plugin-wb-platform';
import { makeStyles } from '@material-ui/core';

import { customViewDetailRouteRef } from '@agilelab/plugin-wb-platform-settings';
import {
  TaxonomySelector,
  useTaxonomySelection,
} from '@agilelab/plugin-wb-practice-shaper';
import { useRouteRef } from '@backstage/core-plugin-api';
import { SearchContextProvider } from '../context/SearchContext';
import { SearchResultsContent } from './SearchResultsContent';
import { useLocation } from 'react-use';
import { usePublishEvent } from '@agilelab/plugin-wb-events';
import { marketplaceCatalogNavigatedTopic } from '@agilelab/plugin-wb-events-common';
import { useEffect } from 'react';
import { WbPage } from '@agilelab/plugin-wb-platform';

const useStyles = makeStyles(
  () => ({
    content: {
      minHeight: 0,
    },
  }),
  { name: 'SearchResultsPage' },
);

export const SearchResultPage = () => {
  const classes = useStyles();
  const { shouldDisable } = useTaxonomySelection();

  const { publish } = usePublishEvent({ generatorSystem: 'marketplace' });
  const location = useLocation();

  useEffect(() => {
    if (location.pathname)
      publish(marketplaceCatalogNavigatedTopic, {
        path: location.pathname,
      });
  }, [publish, location.pathname]);

  const getCustomViewDetailRoute = useRouteRef(customViewDetailRouteRef);

  // Set Search Page as last main page
  const [, setLastVisitedMainPage] = useLastVisitedMainPage(
    MainPageType.MARKETPLACE,
  );
  setLastVisitedMainPage();

  const [, setSessionQueryString] = useSessionQueryString();
  useSearchParamChangeObserver(
    (_previousSearch: string, currentSearch: string) => {
      setSessionQueryString(currentSearch);
    },
  );
  return (
    <SearchContextProvider>
      <WbPage themeId="home">
        <WbHeader
          title="Search"
          titleContainerStyle={{ flex: 'none' }}
          breadcrumbs={
            <WbBreadcrumbs aria-label="breadcrumb">
              <WbBreadcrumb>Data Marketplace</WbBreadcrumb>
              <WbBreadcrumb>Search</WbBreadcrumb>
            </WbBreadcrumbs>
          }
        >
          <CustomViewSummaryMenu
            getUrlByid={id => getCustomViewDetailRoute({ pageId: id })}
            withMenu
            customViewIds={[
              'marketplace_search_system',
              'marketplace_search_component',
            ]}
          />
          <WbHeaderActions containerStyle={{ marginLeft: 'auto' }}>
            {!shouldDisable && <TaxonomySelector />}
            <WbEnvironmentSelector />
          </WbHeaderActions>
        </WbHeader>
        <Content className={classes.content}>
          <SearchResultsContent />
        </Content>
      </WbPage>
    </SearchContextProvider>
  );
};
